import type { CheckboxGroupProps } from '@base-ui/react';

import { CheckboxGroup as BaseCheckboxGroup, Fieldset as BaseFieldset } from '@base-ui/react';

type Props = CheckboxGroupProps;

export const CheckboxGroup = ({ ...delegated }: Props) => {
  return <BaseFieldset.Root render={<BaseCheckboxGroup {...delegated} />} />;
};
